import Text from '@cartwhl/ui/base/TextNew';

export default function DashboardAccessEmptyState() {
  return (
    <Text token="14/medium" className="text-secondary text-pretty">
      You don&apos;t have access to any applets yet. Sign in or{' '}
      <a
        href="mailto:support@getcartwheel.com"
        target="_blank"
        rel="noreferrer"
        className="text-blue underline"
      >
        contact support
      </a>{' '}
      to get access.
    </Text>
  );
}
